import { render, staticRenderFns } from "./text-raw.vue?vue&type=template&id=178e2f28&scoped=true"
import script from "./text-raw.vue?vue&type=script&lang=js"
export * from "./text-raw.vue?vue&type=script&lang=js"
import style0 from "./text-raw.vue?vue&type=style&index=0&id=178e2f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e2f28",
  null
  
)

export default component.exports